// Office "Service Records" page (route /office/jobsheets). The completed service visits
// (PPM service, LOLER and remedial repair) and the work recorded on site -- call-out visits
// live on the Call-outs page, so a record appears on exactly one of the two (Session AB, Item 1).
// The list + per-row sheet + office approval all live in the shared JobSheetList.
//
// SESSION SC7A: the "Release and send" button that sat here is gone. Awaiting release and Ready to send are tabs of the Servicing hub now
// (the strip above this page). From the menu that is Servicing, then the tab: two presses, as before (the old button was one press on this page).
//
// Session AR Item 11: an "Add service record" button creates a backdated completed record (for a
// lift serviced before V2 went live) so it appears here, on the lift history and in the customer
// portal. It does not email, invoice or generate a PDF; it just writes the history record.
// (Session ACG: the modal itself moved to AddServiceRecordModal.tsx so the dashboard's
// "+ Add a service" quick action reuses it.)
import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "../../components/Button";
import { PageHeader } from "../../components/PageHeader";
import { JobSheetList } from "./JobSheetList";
import { AddServiceRecordModal } from "./AddServiceRecordModal";

export function JobSheetsPage() {
  const [addOpen, setAddOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div>
      <PageHeader
        className="mb-4"
        title="Service records"
        subtitle="Completed service visits and the work recorded on site. Select a row to see the full sheet."
        actions={
          <>
            <Button onClick={() => setAddOpen(true)} icon={<Plus aria-hidden size={15} />}>
              Add service record
            </Button>
          </>
        }
      />
      <JobSheetList
        key={reloadKey}
        kind="service"
        emptyActiveText="No completed service records yet."
        emptyArchivedText="No archived service records."
      />
      {addOpen && (
        <AddServiceRecordModal
          onClose={() => setAddOpen(false)}
          onCreated={() => {
            setReloadKey((k) => k + 1);
          }}
        />
      )}
    </div>
  );
}
